import React from "react";
import {IRouteProps} from "../../../ts/manager/view/ViewInterface";

const NoContent = (props:IRouteProps) =>
{
    return <>

        <div className="container">

            <div className="row">

                <div className="col-12 text-center">
                    Nothing has been added yet
                </div>
            </div>
        </div>
    </>;
}

export default NoContent;